import React, { useState, useEffect } from 'react'
import { useStyles } from './ModifsInfosPersoStyle'
import FormInformation from '../../components/forms/FormInformation/FormInformation'
import FormEtatCivil from '../../components/forms/FormEtatCivil/FormEtatCivil'
import FormAdresse from '../../components/forms/FormAdresse/FormAdresse'
import FormCoordonnees from '../../components/forms/FormCoordonnees/FormCoordonnees'
import FormInfoGeneral from '../../components/forms/FormInfoGeneral/FormInfoGeneral'
import FormContactUrgent from '../../components/forms/FormContactUrgent/FormContactUrgent'
import FormRattachementEnfants from '../../components/forms/FormRattachementEnfants/FormRattachementEnfants'

import allActions from '../../redux/actions/user'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'

//Material UI
import Card from '@material-ui/core/Card'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Skeleton from '@material-ui/lab/Skeleton'

//Icons
import PermIdentityIcon from '@material-ui/icons/PermIdentity'
import AccessibilityOutlinedIcon from '@material-ui/icons/AccessibilityOutlined'
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined'
import ContactMailOutlinedIcon from '@material-ui/icons/ContactMailOutlined'
import PermContactCalendarOutlinedIcon from '@material-ui/icons/PermContactCalendarOutlined'
import EmojiPeopleOutlinedIcon from '@material-ui/icons/EmojiPeopleOutlined'
import PersonAddIcon from '@material-ui/icons/PersonAdd'


export default function ModifsInfosPerso() {

  const { enqueueSnackbar } = useSnackbar()
  const classes = useStyles()
  const dispatch = useDispatch()

  const [currentCategory, setcurrentCategory] = useState(0)
  const [categories, setCategories] = useState([])
  const [nextMode, setnextMode] = useState(false)
  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''

  const userID = state.user.id
  let centres = []
  let professions = []
  let pays = []
  let situations = []
  let adresseTypes = []
  let comites = []
  let postCodes = []
  let liensQualite = []

  useEffect(() => {
    if (userID !== undefined) {
      refresh()
    }
  }, [userID])


  function checkDataCompleted(info) {
    if(info) {
      if(info[0]?.civilite && info[0]?.nom && info[0]?.prenom && info[0]?.profession && info[1]?.date && info[2]?.adresseL1 && info[2]?.adresseNum && info[2]?.codePostal && info[2]?.ville && info[3]?.phone && info[3]?.email && info[4]?.centre) {
        dispatch(allActions.setDataCompleted(true))
      }
      else {
        dispatch(allActions.setDataCompleted(false))
      }
    }
  }

  /**
   * Fetch all the personnal informations off the user
   */
  async function getInfos() {
   
    dispatch(allActions.setLoading(true))
    return new Promise(async (resolve) => {
      try {
        const url = 'api/users/modifs-infos-perso/' + userID
        const res = await fetch(process.env.REACT_APP_API_PATH + url, {
          method: 'get',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': token
          }
        })
        const json = await res.json()
        resolve({ res: res, json: json })
      } catch (err) {
        resolve({ err: 'Service non disponible' })
      } finally {
        dispatch(allActions.setLoading(false))
      }
    })
  }

  /**
   * Refresh the form with the informations
   */
  async function refresh(infos) {
    checkDataCompleted(infos)
    if (!infos) {
      const res = await getInfos()
      if (res.err) {
        console.log('ERR: ' + res.err)
        enqueueSnackbar('Erreur: ' + res.err, { variant: `error` })
        return
      }
      if (res.json.err) {
        console.log('ERR: ' + res.json.err)
        enqueueSnackbar('Erreur: ' + res.json.err, { variant: `error` })
        return
      }
      infos = res.json.data
      centres = res.json.centres
      professions = res.json.professions
      pays = res.json.pays
      situations = res.json.situations
      adresseTypes = res.json.adresseTypes
      comites = res.json.comites
      postCodes = res.json.postCodes
      liensQualite = res.json.liensQualite
    }

    setCategories([
      { name: 'Informations', icon: <PermIdentityIcon />, component: <FormInformation formClass={classes.form} defaultValues={infos[0]} refresh={refresh} professions={professions} id={userID} nextTab={() => goTab(1)}/> },
      { name: 'Etat civil', icon: <AccessibilityOutlinedIcon />, component: <FormEtatCivil formClass={classes.form} defaultValues={infos[1]} refresh={refresh} pays={pays} situations={situations} id={userID} previousTab={() => goTab(0)} nextTab={() => goTab(2)}/> },
      { name: 'Adresse', icon: <HomeOutlinedIcon />, component: <FormAdresse formClass={classes.form} defaultValues={infos[2]} refresh={refresh} pays={pays} adresseTypes={adresseTypes} postCodes={postCodes} id={userID} previousTab={() => goTab(1)} nextTab={() => goTab(3)}/> },
      { name: 'Coordonnées', icon: <ContactMailOutlinedIcon />, component: <FormCoordonnees formClass={classes.form} defaultValues={infos[3]} refresh={refresh} id={userID} previousTab={() => goTab(2)} nextTab={() => goTab(4)}/> },
      { name: 'Informations générales', icon: <PermContactCalendarOutlinedIcon />, component: <FormInfoGeneral formClass={classes.form} defaultValues={infos[4]} refresh={refresh} centres={centres} comites={comites} id={userID} previousTab={() => goTab(3)} nextTab={() => goTab(5)}/> },
      { name: 'Rattacher des enfants', icon: <PersonAddIcon />, component: <FormRattachementEnfants formClass={classes.form} defaultValues={infos[5]} liensQualite={liensQualite} refresh={refresh} id={userID} previousTab={() => goTab(4)} nextTab={() => goTab(6)} /> },
      { name: 'Contact d\'urgence', icon: <EmojiPeopleOutlinedIcon />, component: <FormContactUrgent formClass={classes.form} pays={pays} adresseTypes={adresseTypes} postCodes={postCodes} defaultValues={infos[6]} dateNaiss={infos[1].date} refresh={refresh} liensQualite={liensQualite} id={userID} previousTab={() => goTab(5)}/> },
    ])

    const user = state.user
    user.nom = infos[0].nom
    user.prenom = infos[0].prenom
    user.photo = infos[0].photo
    dispatch(allActions.setUser(user, state.accessToken))

    if(infos[0].profession === null) setnextMode(true)
  }

  function goTab(tabId) {
    setcurrentCategory(tabId)
  }

  function tabChange(e, newCategory) {
    if (!nextMode) setcurrentCategory(newCategory)
  }

  useEffect(() => {
    if (userID !== undefined) refresh()
  }, [nextMode])

  return (
    <div className={classes.root} id="modifs-info">
      <Card className={classes.card}>
        <h2 className={classes.title}>Données personnelles</h2>

        <Tabs
          value={currentCategory}
          onChange={tabChange}
          variant="scrollable"
          scrollButtons="on"
          indicatorColor="primary"
          textColor="primary"
          aria-label="scrollable force tabs example"
        >

          {categories.map((c, i) => (<Tab wrapped label={c.name} icon={c.icon} key={i} />))}
        </Tabs>

        <div className={classes.category}>
          {(!categories.length) ? (
            <div className={classes.skeleton}>
              <Skeleton variant="rect" height={40} />
              <div className="line">
                <Skeleton variant="rect" width="20%" height={40} />
                <Skeleton variant="rect" width="40%" height={40} />
                <Skeleton variant="rect" width="40%" height={40} />
              </div>

              <Skeleton variant="rect" height={40} />
              <Skeleton variant="rect" width="40%" height={40} />
              <Skeleton variant="rect" height={40} />
              <Skeleton variant="circle" width={40} height={40} />

            </div>
          ) :
            categories[currentCategory]?.component
          }

        </div>
      </Card>
    </div >
  )
}
